import React from 'react'
import Background from '../images/background_img.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faBed,
  faShower,
  faWaterLadder,
  faHouse,
  faTree,
  faPaw,
} from '@fortawesome/free-solid-svg-icons'
import Mapbox from '../components/Mapbox'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { useRef } from 'react'

const Home = () => {
  const { t } = useTranslation()
  const nextSectionRef = useRef(null)

  return (
    <>
      <Helmet>
        <title>Les Grottes : house to rent in the South of France</title>
        <meta
          name="description"
          content="This large and comfortable house is available to rent in the region of Luberon, France."
        />
      </Helmet>
      <div className="bigContainer">
        <div className="header relative">
          <img
            src={Background}
            alt="maisons aux volets bleus"
            className="backgroundImg w-full h-screen object-cover brightness-50"
          />
          <div className="textLogo absolute left-1/2 top-1/4 transform -translate-x-1/2 font-logo lg:text-9xl text-5xl sm:text-6xl md:text-7xl text-white pt-10">
            Les Grottes
          </div>
          <div className="subtitle absolute left-1/2 top-[40%] sm:top-2/4 transform -translate-x-1/2 text-provence font-text text-base sm:text-xl text-center pt-5 px-4">
            {t('slogan')}
          </div>
          <div className="icon text-white text-2xl absolute left-1/2 top-3/4 pt-20 animate-bounce -translate-x-1/2 cursor-pointer">
            <FontAwesomeIcon
              icon={faArrowDown}
              onClick={() =>
                nextSectionRef.current.scrollIntoView({ behavior: 'smooth' })
              }
            />
          </div>
        </div>

        <section ref={nextSectionRef} className="scroll-mt-20">
          <div className="iconsPart">
            <div className="Iconscontainer grid grid-cols-2 sm:grid-cols-3 gap-8 pb-10 px-8 sm:px-16 md:px-24 lg:px-32 pt-8">
              <div className="bedIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faBed}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  {t('sleep-icon')}
                </p>
              </div>
              <div className="showerIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faShower}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  {t('bathroom-icon')}
                </p>
              </div>
              <div className="poolIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faWaterLadder}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  {t('swimming-icon')}
                </p>
              </div>
              <div className="houseIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faHouse}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  ± 340 m²
                </p>
              </div>
              <div className="forestIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faTree}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  {t('forest-icon')}
                </p>
              </div>
              <div className="pawIcon flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faPaw}
                  className="text-3xl text-provence"
                />
                <p className="text-center pt-4 font-text text-sm md:text-lg">
                  {t('pet-icon')}
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="bookNow w-full py-10">
          <div className="flex flex-col items-center">
            <a
              className="bg-provence text-white font-bold font-text py-4 px-8 rounded-2xl hover:bg-blue-400"
              href="/photos"
            >
              {t('photos')}
            </a>
          </div>
        </div>

        <div className="description mt-5 px-6 sm:px-12 md:px-20 lg:px-40">
          <p className="text-center font-text leading-7">
            {t('text')}
          </p>
        </div>

        <div className="">
          <div className="">
            <Mapbox />
          </div>
        </div>
      </div>
    </>
  )
}

export default Home
